import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import useAuth from '../../../features/hooks/useAuth';
import UnivComplaintTable from '../UnivComplaintTable';

const Container = styled.div`
  margin-top: 20px;
`;

const CompSentboxTable = ({ subTabValue, handleEditclick }) => {
  const Auth = useAuth();
  const [filterProps, setFilterProps] = useState({});  

  useEffect(() => {
    if (!Auth?.id) return;
  
    let updatedFilterProps = {};
    let sent_to_tag_filter = [];
  
    switch (subTabValue) {
      case 0:
        // User Sentbox - complaints user has filed or escalated
        sent_to_tag_filter = [
          "complaint_created",
          "escalated_to_l1"
        ];
        break;
      case 1:
        // Support Staff Sentbox
        sent_to_tag_filter = [
          "fwd_supv_fr_close",
          "compl_on_hold"
        ];
        break;
      case 2:
        // Supervisor Sentbox
        sent_to_tag_filter = [
          "compl_closed_by_supv",
          "fwd_reaasign_ss",
          "fwd_to_oldss_foraction",
          "supv_resolved_fwd_l1"
        ];
        break;
      case 3:
        // L1Support Sentbox
        sent_to_tag_filter = [
          "compl_closed_by_l1",
          "l1_fwd_sup_foraction"
        ];
        break;
      case 4:
        // L2Support Sentbox
        sent_to_tag_filter = [
          "compl_closed_by_l1",
          "l1_fwd_sup_foraction"
        ];
        break;
      case 5:
        // Closed Sentbox
        sent_to_tag_filter = [];
        break;
      
      default:
        sent_to_tag_filter = [];
    }
  
    // Filter for sentbox - show complaints where current user sent actions with specific tags
    // Using similar structure to consumable requests
    
    if (subTabValue === 5) {
      // For Closed tab, filter by status = "Closed" and user in flow
      updatedFilterProps = {
        perm_curr_status: ["Closed"],
        flow_users: [Auth.id], // User was involved in the flow
      };
    } else if (subTabValue === 0 || subTabValue === 1 || subTabValue === 2 || subTabValue === 3 || subTabValue === 4) {
      // For all active sentboxes, exclude closed complaints
      updatedFilterProps = {
        req_data_sent_to_tags: { 
          id: Auth.id, 
          tags: sent_to_tag_filter?.length ? sent_to_tag_filter : ["complaint_created"] 
        },
        flow_users: [Auth.id],
        perm_curr_status: ["Open", "OnHold"], // Explicitly exclude Closed status for all roles
      };
    } else {
      // For any other tabs, use normal filtering
      updatedFilterProps = {
        req_data_sent_to_tags: { 
          id: Auth.id, 
          tags: sent_to_tag_filter?.length ? sent_to_tag_filter : ["complaint_created"] 
        },
        flow_users: [Auth.id],
      };
    }
  
    setFilterProps(prevProps => {
      return JSON.stringify(prevProps) !== JSON.stringify(updatedFilterProps) ? updatedFilterProps : prevProps;
    });
    
  }, [Auth?.id, subTabValue]);

  const columnFilter = [
    "ComplaintNo", "AssetId", "AssetName", "RegisteredBy", "Subject", "ComplaintCat", 
    "ComplaintFilingTime", "AssignedTo", "Status", "ViewDetail"
  ];

  console.log('CompSentboxTable filterProps:', filterProps);

  // Handle the view detail functionality similar to handleEditclick
  const [rowid, setRowid] = useState('');
  const [viewDetail, setViewDetail] = useState(false);

  // When a row is clicked for viewing details, call the original handleEditclick
  useEffect(() => {
    if (viewDetail && rowid) {
      // Find the row data from the complaint
      // Since UnivComplaintTable doesn't directly pass row data, 
      // we'll need to handle this in the parent component
      handleEditclick && handleEditclick(null, { _id: rowid }, "ViewComplaint");
      setViewDetail(false);
    }
  }, [viewDetail, rowid, handleEditclick]);

  return (
    <>    
      <UnivComplaintTable
        filterProps={filterProps}  
        columnFilter={columnFilter}
        setRowid={setRowid}
        setViewDetail={setViewDetail}
        viewType="sentbox"
      />   
    </>
  );
};

export default CompSentboxTable; 